import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export const useFeatures = () => {
  const { data } = useQuery({ queryKey: ["features"], queryFn: () => api.get("/features").then((r) => r.data), staleTime: 300000 });
  return data || { pots_enabled: false, loading: true };
};
